import { PixiContext } from "common/pixi";
import { createApplication, createCenterContainer } from "common/pixi/app";
import { Waiter } from "common/promises";
import { ReesizeEventHandler } from "common/resize";
import * as LoadingAnimation from "./loadingAnimation";
import { Background, Button, loadSheets, Mum, Title } from "./resources";
import { letterbox } from "./screen";
export class Scene {
    async start({ parentSelector, sound, transitionImage, }) {
        const resizer = new ReesizeEventHandler();
        letterbox(resizer);
        const app = createApplication(parentSelector, transitionImage);
        const pixiContext = new PixiContext(app);
        const sheets = await loadSheets();
        const elements = loadAllElements({ sheets, pixiContext });
        const buttonAnimation = elements.button.animate();
        const mumAnimation = elements.mum.animate();
        addElementsToScene({ elements, app });
        transitionImage === null || transitionImage === void 0 ? void 0 : transitionImage.dispose();
        await LoadingAnimation.run({ elements, sound, pixiContext });
        const waiter = new Waiter();
        elements.button.callback = async () => {
            waiter.trigger();
        };
        await waiter.wait();
        buttonAnimation.canceler.cancel();
        mumAnimation.canceler.cancel();
        sound.stopLoop("background");
        sound.stopLoop("pleaseClick");
        sound.dispose();
        await elements.button.dispose();
        pixiContext.dispose();
        app.destroy(true);
        PIXI.utils.destroyTextureCache();
        $("#pixi-canvas").remove();
        await buttonAnimation.promise;
        await mumAnimation.promise;
        resizer.drop();
    }
}
function loadAllElements({ sheets, pixiContext, }) {
    return {
        button: new Button(pixiContext, sheets),
        title: new Title(pixiContext, sheets),
        background: new Background(pixiContext, sheets),
        mum: new Mum(pixiContext, sheets),
    };
}
function addElementsToScene({ elements: { background, button, mum, title }, app, }) {
    const centerContainer = createCenterContainer();
    app.stage.addChild(centerContainer);
    const pixiObjects = [
        background.sprite,
        title.sprite,
        button.sprite,
        mum.sprite,
    ];
    for (const pixiObject of pixiObjects) {
        pixiObject.visible = false;
        centerContainer.addChild(pixiObject);
    }
}
//# sourceMappingURL=main.js.map